import { render, staticRenderFns } from "./splash_product_display.vue?vue&type=template&id=09c4795a&"
import script from "./splash_product_display.vue?vue&type=script&lang=js&"
export * from "./splash_product_display.vue?vue&type=script&lang=js&"
import style0 from "./splash_product_display.vue?vue&type=style&index=0&id=09c4795a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports